import { Component, Vue } from 'vue-property-decorator'
import carritos from '@/store/modules/CarritoModule'
import auth from '@/store/modules/AuthModule'

@Component
export default class App extends Vue {
  mounted () {
    carritos.leadCarrito()
    const token = window.sessionStorage.getItem('token')
    if (token) {
      auth.addToken(token)
    }
  }
}
